import {
  ADD_TO_CART,
  UPDATE_QUANTITY,
  REMOVE_FROM_CART,
  TOGGLE_CART_SIDEBAR,
  CLEAR_CART,
} from '../actions/cartActions';

const initialState = {
  items: [],
  isCartSidebarOpen: false,
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const newItem = action.payload;
      const existingItem = state.items.find(
        (item) =>
          item.id === newItem.id &&
          item.size === newItem.size &&
          item.color === newItem.color
      );

      if (existingItem) {
        existingItem.quantity += newItem.quantity;
        return { ...state, items: [...state.items], isCartSidebarOpen: true };
      }

      return { ...state, items: [...state.items, newItem], isCartSidebarOpen: true };
    }

    case UPDATE_QUANTITY: {
      const { id, size, color, quantity } = action.payload;
      return {
        ...state,
        items: state.items.map((item) =>
         {
          const isMatch =
          item.id === id &&
          (size === undefined || item.size === size) &&
          (color === undefined || item.color === color);
        return isMatch ? { ...item, quantity } : item;
         }
        ),
      };
    }

    case REMOVE_FROM_CART: {
      const { id, size, color } = action.payload;
      return {
        ...state,
        items: state.items.filter(
          (item) =>
            item.id !== id || item.size !== size || item.color !== color
        ),
      };
    }
    case CLEAR_CART:
      return { ...state, items: [] };
    
    case TOGGLE_CART_SIDEBAR:
      return {
        ...state,
        isCartSidebarOpen: !state.isCartSidebarOpen,
      };

    default:
      return state;
  }
};
